import { createTheme, darken, lighten } from "@mui/material/styles";
import createPalette, {
  IPaletteOptions,
} from "@mui/material/styles/createPalette";
import { TypographyOptions } from "@mui/material/styles/createTypography";

export const white = "#FFFFFF";
export const black = "#000000";

// declare module "@mui/material/Typography" {
//   interface TypographyPropsVariantOverrides {
//     title1: true;
//     title2: true;
//     title3: true;
//     title4: true;
//     title5: true;
//     title6: true;
//     title7: true;
//     title8: true;
//     overline2: true;
//     overline4: true;
//     captionUnderline: true;
//     caption2: true;
//     caption1: true;
//   }
// }

// interface ExtendedTypographyOptions extends TypographyOptions {
//   title1: React.CSSProperties;
//   title2: React.CSSProperties;
//   title3: React.CSSProperties;
//   title4: React.CSSProperties;
//   title5: React.CSSProperties;
//   title6: React.CSSProperties;
//   title7: React.CSSProperties;
//   title8: React.CSSProperties;
//   overline2: React.CSSProperties;
//   overline4: React.CSSProperties;
//   captionUnderline: React.CSSProperties;
//   caption2: React.CSSProperties;
//   caption1: React.CSSProperties;
// }

// declare module "@mui/material/styles/createPalette" {
//   export interface IPaletteOptions extends PaletteOptions {
//     mustard: {
//       main: string;
//       dark: string;
//       light: string;
//       contrastText: string;
//     };
//     red: {
//       main: string;
//       dark: string;
//       light: string;
//       contrastText: string;
//     };
//     beige: {
//       main: string;
//       dark: string;
//       light: string;
//       contrastText: string;
//     };
//   }
// }

export const palette = createPalette({
  white: {
    main: "#FFFFFF",
  },
  black: {
    main: "#0E0F19",
  },
  mustard: {
    main: "#FFD27D",
    dark: darken("#FFD27D", 0.2),
    light: lighten("#FFD27D", 0.2),
    contrastText: white,
  },
  red: {
    main: "#F22824",
    dark: darken("#F22824", 0.2),
    light: lighten("#F22824", 0.2),
    contrastText: white,
  },
  beige: {
    main: "#E5B863",
    dark: darken("#E5B863", 0.2),
    light: lighten("#E5B863", 0.2),
    contrastText: white,
  },
  purple: {
    main: "#345C63",
    dark: darken("#345C63", 0.2),
    light: lighten("#345C63", 0.2),
    contrastText: white,
  },
  blue: {
    main: "#0085B4",
    dark: darken("#0085B4", 0.2),
    light: lighten("#0085B4", 0.2),
    contrastText: white,
  },
  darkblue: {
    main: "#1C4F82",
    dark: darken("#1C4F82", 0.2),
    light: lighten("#1C4F82", 0.2),
    contrastText: white,
  },
  darkgreen: {
    main: "#009A88",
    dark: darken("#009A88", 0.2),
    light: lighten("#009A88", 0.2),
    contrastText: white,
  },
  primary: {
    main: "#09507F",
    dark: darken("#09507F", 0.2),
    light: lighten("#09507F", 0.2),
    contrastText: white,
  },
  secondary: {
    main: "#009A88",
    dark: darken("#009A88", 0.2),
    light: lighten("#009A88", 0.8),
    contrastText: white,
  },
  success: {
    main: "#009A88",
    dark: darken("#009A88", 0.2),
    light: lighten("#009A88", 0.5),
    contrastText: white,
  },
  warning: {
    main: "#ED8A2F",
    dark: darken("#ED8A2F", 0.2),
    light: lighten("#ED8A2F", 0.2),
    contrastText: white,
  },
  error: {
    main: "#F15C5C",
    dark: darken("#F15C5C", 0.2),
    light: lighten("#F15C5C", 0.2),
    contrastText: white,
  },
  info: {
    main: "#5C7DF1",
    dark: darken("#5C7DF1", 0.2),
    light: lighten("#5C7DF1", 0.2),
    contrastText: white,
  },
  grey: {
    50: "#F5F5F7",
    100: "#EEEEF1",
    150: "#E7E8EB",
    200: "#DBDFE6",
    300: "#ADB2BE",
    700: "#6E7385",
    800: "#404350",
    900: "#0E0F19",
  },
  background: {
    paper: "#F8F9F9",
  },
});

export const typography = {
  fontFamily: "Futura PT Book",
  h1: {
    fontSize: 48,
    lineHeight: "63.6px",
    fontWeight: 700,
    letterSpacing: 0,
  },
  h2: {
    fontSize: 48,
    lineHeight: "63.6px",
    fontWeight: 400,
  },
  h3: {
    fontSize: 26,
    lineHeight: "130%",
    fontWeight: 700,
    letterSpacing: 0,
  },
  h4: {
    fontSize: 18,
    lineHeight: "140%",
    fontWeight: 700,
    letterSpacing: 0,
  },
  h5: {
    fontSize: 16,
    lineHeight: "140%",
    fontWeight: 700,
    letterSpacing: 0,
  },
  h6: {
    fontSize: 14,
    lineHeight: "140%",
    fontWeight: 700,
    letterSpacing: 0,
  },
  body1: {
    fontSize: "1vw",
    // lineHeight: "23.08px",
    fontWeight: 400,
    fontFamily: "Futura PT Book",
  },
  body2: {
    // fontSize: "14px",
    // // lineHeight: "160%",
    // fontWeight: 400,
    // letterSpacing: 0,
    fontFamily: "Larken DEMO medium",
  },
  subtitle1: {
    fontSize: 12,
    lineHeight: "160%",
    fontWeight: 700,
    letterSpacing: 0,
    fontFamily: "Futura PT Book",
  },
  subtitle2: {
    fontSize: 12,
    fontWeight: 400,
    textTransform: "uppercase",
    letterSpacing: 0.02,
    fontFamily: "Futura PT Book",
  },
  caption: {
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 0,
    fontFamily: "Futura PT Book",
  },
  title1: {
    fontSize: "48px",
    lineHeight: "140%",
    letterSpacing: "0%",
    fontWeight: "bold",
    fontFamily: "Futura PT Book",
  },
  title2: {
    fontSize: "20px",
    lineHeight: "140%",
    letterSpacing: "0px",
    fontWeight: "bold",
    fontFamily: "Futura PT Book",
  },
  title3: {
    fontSize: "22px",
    lineHeight: "130%",
    letterSpacing: "0%",
    fontWeight: "bold",
    fontFamily: "Futura PT Book",
  },
  title4: {
    fontSize: "18px",
    lineHeight: "140%",
    letterSpacing: "0px",
    fontWeight: "bold",
    fontFamily: "Futura PT Book",
  },
  title5: {
    fontSize: "16px",
    lineHeight: "140%",
    letterSpacing: "0px",
    fontWeight: "bold",
    fontFamily: "Futura PT Book",
  },
  title6: {
    fontSize: "14px",
    lineHeight: "140%",
    letterSpacing: "0px",
    fontWeight: "bold",
    fontFamily: "Futura PT Book",
  },
  title7: {
    fontSize: "15px",
    lineHeight: "140%",
    letterSpacing: "0px",
    fontWeight: "bold",
    fontFamily: "Futura PT Book",
  },
  title8: {
    fontSize: "12px",
    lineHeight: "140%",
    letterSpacing: "0px",
    fontWeight: "bold",
    fontFamily: "Futura PT Book",
  },
  overline2: {
    fontSize: "10px",
    lineHeight: "140%",
    letterSpacing: "0.02rem",
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Futura PT Book",
  },
  overline4: {
    fontSize: "20px",
    lineHeight: "140%",
    letterSpacing: "0px",
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Futura PT Book",
  },
  captionUnderline: {
    fontSize: "20px",
    lineHeight: "140%",
    letterSpacing: "0px",
    fontWeight: 400,
    textDecoration: "underline",
    fontFamily: "Futura PT Book",
  },
  caption2: {
    fontStyle: "normal",
    fontSize: "12px",
    lineHeight: "160%",
    letterSpacing: "0px",
    fontWeight: 400,
    fontFamily: "Futura PT Book",
  },
  caption1: {
    fontStyle: "normal",
    fontSize: "10px",
    lineHeight: "160%",
    letterSpacing: "0px",
    fontWeight: 400,
    fontFamily: "Futura PT Book",
  },
};

export const themeCommon = createTheme({
  palette,
  typography,
  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 550,
      lg: 960,
      xl: 1200,
      xxl: 1900,
    },
  },
  spacing: (value) => value * 4,
});

export default createTheme(themeCommon);
